import React, { useEffect, useState } from 'react'
import ApiService from '../../functions/apiService';
import { useSelector } from 'react-redux';
import MyTable from './MyTable';
import { getGridStringOperators } from '@mui/x-data-grid';
import { Checkbox } from '@mui/material';
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { toast } from 'react-toastify';

export default function DutyCrew({isReload, setIsReload}) {
	let data = useSelector((state) => state.dashboardReducer.Data)
	const [row, setRow] = useState([]);
	const [unAssign, setUnAssign] = useState(null);

	const getDetails = async () => {
		await ApiService.get('/todayDetails', { date: data.date }, 'todayDetails')
			.then(({ data }) => {
				setRow(data.data)
			})
	}
	useEffect(() => {
		getDetails()
	}, [data, isReload])

	let columns = [
		{
			field: " ",
			headerName: "",
			flex: 1,
			maxWidth: 70,
			renderCell: (params) => (
				params?.row?.StatusName == "Filled" ? (
					<Checkbox
						checked={params?.row?.id == unAssign?.id}
						onClick={() => setUnAssign(e => e == null ? params?.row : null)}
						disabled={unAssign != null && params?.row?.id != unAssign?.id}
					/>)
					: null
			)
		},
		{
			field: "ShiftName",
			headerName: "Shift",
			flex: 1,
			maxWidth: 170,
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
		},
		{
			field: "AssignmentText",
			headerName: "Assignment",
			flex: 1,
			maxWidth: 190,
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
		},
		{
			field: "DetailText",
			headerName: "Description",
			flex: 1,
			maxWidth: 210,
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
		},
		{
			field: "PositionName",
			headerName: "Rank",
			flex: 1,
			maxWidth: 170,
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
		},
		{
			field: "EMT",
			headerName: "EMT",
			flex: 1,
			maxWidth: 170,
			filterOperators: getGridStringOperators().filter(
				(operator) => operator.value === "contains"
			),
		},
		{
			field: "text",
			headerName: "Status",
			flex: 1,
			maxWidth: 250,
			renderCell: (params) => (
				<div
					style={{
						color: params?.row?.StatusColor,
					}}
				>
					{params?.row?.StatusName == "Filled" ? params?.row?.StatusText : 'Open'}
				</div>)
		}
	]

	const unAssignShift = () => {
		let body = {
			"Shift_Date": data?.date,
			"Shift_Number": unAssign?.ShiftNumber,
			"Emp_Code": unAssign?.EmpCode
		};
		ApiService.post("/unassignShift", body)
			.then((data) => {
				toast.success(data?.message)
				getDetails()
				setUnAssign(null)
				setIsReload(val=>!val)
			})
			.catch((err) => {
				toast.error(err?.data?.message)
			})
	}

	return (
		<div>
			{row && row.length > 0 &&
				<>
					<div className='m-3 pb-2'>
						<p className='my-2'>Duty Crews</p>
						<MyTable
							rows={row}
							columns={columns}
							useTopFilter={false}
							hideFooter={true}
							checkboxSelection={false}
						/>
					</div>
					<div className='m-3 pb-2' style={{ display: 'flex', justifyContent: 'flex-start' }}>
						<ButtonTheme type='submit' variant="filled" color='primary'
							className='px-5'
							onClick={() => unAssignShift()}
							disabled={row.find(a => a?.StatusName == "Filled") ? false : true}
						>
							Un-Assign
						</ButtonTheme>
					</div>
				</>
			}
		</div>
	)
}
